import {MODAL_TYPE} from './types';

export const getModal = data => ({
  type: MODAL_TYPE,
  payload: data,
});
